import {useTab, Badge, Tab} from '@chakra-ui/react';
import type {TabProps, BadgeProps} from '@chakra-ui/react';
import React, {useEffect} from 'react';

import {useTabsStyleConfig} from '../../theme-config';
import {mergeSXProp} from '../../utils/merge-sx-prop';

type Props = {
  count: number | undefined;
  onBadgeChange?: (isBadgeVisible: boolean) => void;
  badgeProps?: BadgeProps;
  isAlwaysVisible?: boolean;
} & TabProps;

const TabBadge = React.forwardRef((props: Props, ref: React.Ref<HTMLButtonElement>) => {
  const {badgeProps, count, onBadgeChange, isAlwaysVisible, ...restProps} = props;
  const tabProps = useTab({...restProps, ref});
  const isSelected = !!tabProps[`aria-selected`];
  const {badge: badgeSx} = useTabsStyleConfig({size: `sm`, variant: `fill`, colorScheme: `brand.primary`});

  const isBadgeVisible = Boolean(isSelected && count && count > 0) || isAlwaysVisible;

  useEffect(() => {
    if (isBadgeVisible) {
      onBadgeChange?.(isBadgeVisible);
    }
  }, [isBadgeVisible, onBadgeChange]);

  return (
    <Tab {...tabProps}>
      {tabProps.children}
      {isBadgeVisible ? (
        <Badge sx={mergeSXProp(badgeSx, badgeProps?.sx)} {...badgeProps}>
          {count}
        </Badge>
      ) : null}
    </Tab>
  );
});

export default TabBadge;
